import ScormAPI2004 from '@/lib/ScormApi/ScormAPI2004'
import JsonFormatter from '@/lib/ScormApi/JsonFormatter'
import { CompletionStatus, SuccessStatus } from "@/lib/ScormApi/Scorm2004/interfaces/CMIInterface"
import ObjectivesObjectInterface from "@/lib/ScormApi/Scorm2004/interfaces/ObjectivesObjectInterface"

export default function ObjectivesObject (api: ScormAPI2004): ObjectivesObjectInterface {
  let _id = ''
  let _success_status = SuccessStatus.UNKNOWN
  let _completion_status = CompletionStatus.UNKNOWN
  let _progress_measure = ''
  let _description = ''

  let score__children = "scaled,raw,min,max"
  let score__scaled = ''
  let score__raw = ''
  let score__min = ''
  let score__max = ''

  return {
    get id () {
      return _id
    },
    set id (id) {
      _id = id
    },
    get success_status () {
      return _success_status
    },
    set success_status (success_status) {
      _success_status = success_status
    },
    get completion_status () {
      return _completion_status
    },
    set completion_status (completion_status) {
      _completion_status = completion_status
    },
    get progress_measure () {
      return _progress_measure
    },
    set progress_measure (progress_measure) {
      _progress_measure = progress_measure
    },
    get description () {
      return _description
    },
    set description (description) {
      _description = description
    },
    score: {
      get _children () {
        return score__children
      },
      set _children (_children) {
        api.throwSCORMError(404)
      },
      get scaled () {
        return score__scaled
      },
      set scaled (scaled) {
        score__scaled = scaled
      },
      get raw () {
        return score__raw
      },
      set raw (raw) {
        score__raw = raw
      },
      get min () {
        return score__min
      },
      set min (min) {
        score__min = min
      },
      get max () {
        return score__max
      },
      set max (max) {
        score__max = max
      },
      toJSON: new JsonFormatter().apply
    },
    toJSON: new JsonFormatter().apply
  }
}
